<div class="pinned-spark" [class.selected]="selected" (click)="onClick()">
  <div class="new-bar" *ngIf="spark.isNew"></div>
  <div class="spark-inner">
    <div class="spark-header">
      <app-spark-tags-overflow
        [tagIds]="spark.tags"
        [tags]="tags"
      ></app-spark-tags-overflow>
      <div class="pinned-spark-actions">
        <app-svg-icon
          *ngIf="spark.hasImage"
          icon="image"
          [size]="24"
          color="var(--color-grey-500)"
        ></app-svg-icon>
        <app-svg-icon
          *ngIf="spark.hasAttachments"
          icon="attachment"
          [size]="24"
          color="var(--color-grey-500)"
        ></app-svg-icon>
        <app-svg-icon
          icon="pin"
          [size]="24"
          [strokeWidth]="1"
          color="var(--color-primary)"
          fill="var(--color-primary)"
        ></app-svg-icon>
        <div
          class="menu-container"
          [id]="'pinned-menu-' + spark.id"
          (click)="onMenuClick($event)"
        >
          <app-svg-icon
            icon="more-horizontal"
            [size]="24"
            [strokeWidth]="3"
            color="var(--color-primary)"
            class="menu-icon"
          />

          <dx-context-menu
            [(visible)]="contextVisible"
            [target]="'#pinned-menu-' + spark.id"
            [hideOnOutsideClick]="true"
            [items]="visibleMenuItems"
            cssClass="gpd-context-menu"
            (onItemClick)="onContextMenuItemClick($event)"
          ></dx-context-menu>
        </div>
      </div>
    </div>
    <div class="spark-author">
      <span class="spark-author-name">
        {{ (configService.userMap$|async)?.[spark.userEmail] || spark.userEmail }}
      </span>
      <span class="spark-author-date" i18n-title="@@lastEditedTooltip"
        [attr.title]="spark.lastModifiedDate ? getLastEditedTooltip() : null">
        {{ spark.dateCreated | timeAgo }}<ng-container *ngIf="spark.lastModifiedDate">, <span i18n="@@lastEdited">last edited</span> {{spark.lastModifiedDate | timeAgo}} <span i18n="@@by">by</span> {{(configService.userMap$ | async)?.[spark.lastModifiedBy] || spark.lastModifiedBy}}</ng-container>
      </span>
    </div>
    <div #pinnedSparkContentContainer class="spark-content">
      <div [innerHTML]="displayContent"></div>
    </div>
  </div>
</div>
